<template>
	<div class="animate__animated animate__fadeIn">
		<h4 class="font-weight-bold">Programas e Serviços</h4>
		<div class="row">
			<div class="col-md-12">
				<h5 class="font-weight-bold">
					É beneficiário de algum programa da Secretária Nacional de Segurança Alimentar e
					Nutricional - SESAN?
				</h5>
			</div>
			<div class="col-md-12">
				<table class="table table-bordered">
					<tbody>
						<tr v-for="item in $root.arrays.beneficiario_sesan" :key="item.id">
							<td :class="checkSesan(item.id) ? 'bg-success' : ''">
								<i :class="checkSesan(item.id) ? 'mdi mdi-check' : ''"></i>
								{{ item.value }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-12">
				<h5 class="font-weight-bold">
					Algum membro da família foi resgatado do trabalho análogo ao de escravo por
					órgão do governo (Ministério Do Trabalho, Polícia Federal etc.)?
				</h5>
			</div>
			<div class="col-md-12">
				<table class="table table-bordered">
					<tbody>
						<tr>
							<td :class="programas_servicos.errad_trab_escravo == 1 ? 'bg-success' : ''">
								<i
									:class="programas_servicos.errad_trab_escravo == 1 ? 'mdi mdi-check' : ''"
								></i>
								Resgatado do trabalho análogo ao de escravidão
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="col-md-12">
				<h5 class="font-weight-bold">
					É beneficiário de algum programa do ministério de minas e energia?
				</h5>
			</div>
			<div class="col-md-12">
				<table class="table table-bordered">
					<tbody>
						<tr
							v-for="item in $root.arrays.beneficiario_ministerio_minas_energia"
							:key="item.id"
						>
							<td :class="checkSesan(item.id) ? 'bg-success' : ''">
								<i :class="checkSesan(item.id) ? 'mdi mdi-check' : ''"></i>
								{{ item.value }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<form-input
				class="pt-3"
				v-model="programas_servicos.cod_cta_energ_unid_consum"
				grid="12"
				label="Preencha o campo abaixo com o número/código de identificação da unidade consumidora, indicado na conta de energia elétrica do domicílio."
			/>
			<div class="col-md-12 pt-3">
				<h5 class="font-weight-bold">
					É atendido por algum programa da Assistência Social?
				</h5>
			</div>
			<div class="col-md-12">
				<table class="table table-bordered">
					<tbody>
						<tr
							v-for="item in $root.arrays.atendido_programa_assistencia_social"
							:key="item.id"
						>
							<td :class="checkSesan(item.id) ? 'bg-success' : ''">
								<i :class="checkSesan(item.id) ? 'mdi mdi-check' : ''"></i>
								{{ item.value }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="col-md-12 pb-2">
				<div class="float-left mr-2">
					<toggle-button
						:sync="true"
						color="#5685D8"
						id="prog_prohab"
						name="prog_prohab"
						v-model="programas_servicos.prog_prohab"
					/>
				</div>
				Esta família não é beneficiária de qualquer programa do Ministério das Cidades
			</div>
			<div v-if="programas_servicos.prog_prohab != 1">
				<div class="col-md-12 pt-3">
					<h5 class="font-weight-bold">
						A familia ou algum membro da familia é beneficiário de algum programa do
						Ministério das Cidades
					</h5>
				</div>
				<div class="col-md-12">
					<table class="table table-bordered">
						<thead>
							<tr>
								<th>Pessoa</th>
								<th>Programa</th>
								<th>Natureza</th>
								<th>Contrato</th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="item.programas_prohab">
								<td>{{ item.programas_prohab.cod_pessoa }}</td>
								<td>{{ checkProhab(item.programas_prohab.programa) }}</td>
								<td>{{ item.programas_prohab.cod_natureza }}</td>
								<td>{{ item.programas_prohab.cod_contrato }}</td>
							</tr>
							<tr v-else>
								<td colspan="4">
									Nenhum membro da familia é beneficiário de algum programa do Ministério das
									Cidades
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: ["item"],
	data() {
		return {
			programas_servicos: {
				vende_leite: null,
				receb_leite: null,
				vende_alim_paa: null,
				receb_alim_paa: null,
				receb_cesta_basica: null,
				refei_restau_popular: null,
				refei_cozinha_comum: null,
				partic_alim_nutricao: null,
				capit_agua_chuva_prod_alim: null,
				receb_cisterna: null,
				horta_comunitaria: null,
				proj_cart_indigena: null,
				feira_pop_mds: null,
				sesan_nenhum: null,
				errad_trab_escravo: null,
				min_energ_tarifa_soc: null,
				min_energ_elet_doacao: null,
				min_energ_luz_n_pagou: null,
				min_energ_nenhum: null,
				cod_cta_energ_unid_consum: null,
				snas_bpc_deficiente: null,
				snas_bpc_idoso: null,
				snas_paif: null,
				snas_crianca_0_6_anos: null,
				snas_grupos_idosos: null,
				snas_abrigo_mulher_vitima: null,
				snas_abrigo_crianca_adoles: null,
				snas_abrigo_idosos: null,
				snas_abrigo_adultos: null,
				snas_abrigo_popul_adulta: null,
				snas_projovem_adolescente: null,
				snas_projovem_urbano: null,
				snas_projovem_campo: null,
				snas_projovem_trabalhador: null,
				snas_habilit_reabilit_deficiencia: null,
				snas_enfrenta_violencia_crianca: null,
				snas_acomp_social_liberdade: null,
				snas_acomp_social_liberdade_comunidade: null,
				snas_orientacao_especial_criancas_adol: null,
				snas_centro_dia_idoso: null,
				snas_atend_domic_idosos_defic: null,
				snas_inclusao_produtiva: null,
				snas_peti: null,
				snas_nenhum: null,
				prog_prohab: null,
				parc_mds: null,
			},
		};
	},
	mounted() {
		if (this.item.programas_servicos) {
			this.programas_servicos = this.item.programas_servicos;
		}
	},
	methods: {
		checkProhab(prohab) {
			const result = this.$root.arrays.programas_prohab.filter(
				(item) => item.id == prohab
			);
			return result ? result[0].value : "";
		},
		checkSesan(servicos) {
			if (this.programas_servicos) {
				return this.programas_servicos[servicos] &&
					this.programas_servicos[servicos] != null
					? true
					: false;
			} else {
				return false;
			}
		},
	},
};
</script>
<style lang="css">
.bg-success {
	background: #a5d6a7 !important;
	color: #424242 !important;
}
</style>
